/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockIcon16Solid = forwardRef('TimeClockIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm.477-10.629a.75.75 0 1 0-1.5 0v3.235c0 .656.367 1.257.95 1.557l2.793 1.435a.75.75 0 1 0 .686-1.335L8.613 7.828a.25.25 0 0 1-.136-.222V4.371Z" })));
});
